/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import cn from 'clsx';
import { AModal, AButton, ASelect } from 'components/Antd';
import { ReactComponent as EmailSvg } from 'assets/icons/New/email.svg';
import { ReactComponent as ShareSvg } from 'assets/icons/New/share.svg';
import T from 'i18n-react';
import classes from './ShareDocumentModal.module.scss';

const ShareDocumentModal = ({
  open,
  onClose,
  selectedRecords,
  onSubmit,
  isProductProfile,
  onEmail,
}) => {
  const tFolders = (selectedRecords || []).filter((item) => !!item.isFolder);
  const tFiles = (selectedRecords || []).filter((item) => !item.isFolder);
  const [val, setVal] = useState('7');
  const options = [
    {
      value: '7',
      label: 'Expire in 7 days',
    },
    {
      value: '14',
      label: 'Expire in 14 days',
    },
    {
      value: '30',
      label: 'Expire in 30 days',
    },
  ];
  const recordsLength = (selectedRecords || []).length || 0;

  return (
    <AModal
      title="Share Via Link"
      open={open}
      onCancel={onClose}
      closable
      width={541}
      className={cn(classes.modalWrapper)}>
      <div className={classes.content}>
        {isProductProfile ? (
          <div className={classes.selectedFileFolderText}>
            <span>Item Selected: {selectedRecords?.length || 0}</span>
            <ul>
              {tFolders.length > 0 && (
                <li>
                  {tFolders.length} folder{tFolders.length === 1 ? '' : 's'}
                </li>
              )}
              {tFiles.length > 0 && (
                <li>
                  {tFiles.length} document{tFiles.length === 1 ? '' : 's'}
                </li>
              )}
            </ul>
          </div>
        ) : (
          <span className={classes.selectedDocumentsText}>
            {recordsLength} Document{recordsLength === 1 ? '' : 's'} Selected
          </span>
        )}

        <div className={classes.selectWrapper}>
          <label>Link Expiry Period</label>
          <ASelect
            placeholder="Select"
            options={options}
            value={val}
            onChange={(tVal) => {
              setVal(tVal);
            }}
            size="large"
            radius="md"
          />
        </div>
      </div>
      <div className={classes.footer}>
        <AButton
          onClick={() => {
            if (onSubmit) onSubmit(val);
          }}
          htmlType="button"
          type="primary"
          icon={<ShareSvg />}
          size="large">
          Copy
        </AButton>
        <AButton
          onClick={() => {
            if (onEmail) onEmail(val);
          }}
          htmlType="button"
          type="primary"
          icon={<EmailSvg />}
          size="large">
          By Email
        </AButton>
      </div>
    </AModal>
  );
};

export default ShareDocumentModal;
